import { DateUtils, HotelRoomUtils, LocalStorageUtils } from '../index';
import { HotelStandalonePaxRestrictionPropsDefault } from '../../models';

const cookieName = 'accommodation-recent-searches';
const dateFormat = 'yyyy-MM-dd';

const buildSearchData = ({ segments, rooms }) => {
    if (!segments || segments.length < 2 || !rooms || rooms.length === 0) {
        return null;
    }
    const destination = segments[0].destination;
    const { adults, kids } = HotelRoomUtils.getTotalAdultsAndKids(rooms, HotelStandalonePaxRestrictionPropsDefault);
    const roomsFormatted = rooms.map((room) => ({
        numAdults: room.adults,
        childrenAges: room.kids,
    }));
    const country = destination.country ? `, ${destination.country}` : null;
    const name = destination.name ? `${destination.name}${country}` : null;
    return {
        geoAccommodation: {
            geoId: destination.id,
            geoType: destination.type,
        },
        totalAdults: adults ?? 2,
        totalChildren: kids ?? 0,
        date: DateUtils.formatDate(new Date(), dateFormat),
        timestamp: Date.now(),
        checkIn: segments[0].date,
        checkOut: segments[1].date,
        name,
        hasResults: false,
        rooms: roomsFormatted,
    };
};

export const RecentAccommodationSearchesLocalStorage = {
    getAccommodationRecentSearches() {
        return LocalStorageUtils.getJSON(cookieName) || [];
    },
    getAccommodationMostRecentSearch() {
        const searches = this.getAccommodationRecentSearches();
        return searches.length > 0 ? searches[searches.length - 1] : null;
    },
    saveAccommodationMostRecentSearch(currentSearch) {
        const searchDataToBeStored = buildSearchData(currentSearch || {});
        const searchData = this.getAccommodationRecentSearches();
        const searchItemExist = searchData.find((searchItem) => {
            const exist = searchItem.geoAccommodation && Object.keys(searchItem.geoAccommodation).every(
                (key) => searchItem.geoAccommodation?.[key] === searchDataToBeStored?.geoAccommodation?.[key],
            );
            if (exist) {
                Object.keys(searchDataToBeStored).filter((key) => key !== 'hasResults').forEach((key) => {
                    if (Object.hasOwn(searchDataToBeStored, key)) {
                        (searchItem[key]) = searchDataToBeStored[key];
                    }
                });
            }
            return exist;
        });

        if (!searchItemExist) {
            searchData.push(searchDataToBeStored);
        }
        LocalStorageUtils.setJSON(cookieName, searchData);
    }
};
